import { useMediaQuery, useTheme } from '@mui/material';

/** Single source of truth for the shell geometry — previously copied into three files. */
export const SIDE_NAV_WIDTH = 280;
export const SIDE_NAV_WIDTH_TABLET = 240;
export const SIDE_NAV_WIDTH_COLLAPSED = 72;
export const TOP_NAV_HEIGHT = 64;

const COLLAPSED_STORAGE_KEY = 'sidenav.collapsed';

export const readCollapsedPreference = (): boolean => {
	try {
		return window.localStorage.getItem(COLLAPSED_STORAGE_KEY) === '1';
	} catch {
		return false;
	}
};

export const writeCollapsedPreference = (collapsed: boolean): void => {
	try {
		window.localStorage.setItem(COLLAPSED_STORAGE_KEY, collapsed ? '1' : '0');
	} catch {
		/* private mode or blocked storage — the preference just won't survive a reload */
	}
};

/**
 * Width the side nav occupies in the page flow. Below `md` it is a temporary
 * drawer over the content, so it reserves nothing.
 */
export const useSideNavWidth = (collapsed: boolean): number => {
	const theme = useTheme();
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
	const mdUp = useMediaQuery(theme.breakpoints.up('md'));
	if (!mdUp) return 0;
	if (collapsed) return SIDE_NAV_WIDTH_COLLAPSED;
	return lgUp ? SIDE_NAV_WIDTH : SIDE_NAV_WIDTH_TABLET;
};

/** Shared easing so the drawer, app bar and content all move as one piece. */
export const useNavTransition = (properties: string[]) => {
	const theme = useTheme();
	return theme.transitions.create(properties, {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	});
};
